module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#news",
      toString: function () {
        return this.url;
      }
    }